import { clamp } from '../utils.mjs';
const number = {
  test: v => typeof v === 'number',
  parse: parseFloat,
  transform: v => v
};
const alpha = Object.assign(Object.assign({}, number), {
  transform: clamp(0, 1)
});
const scale = Object.assign(Object.assign({}, number), {
  default: 1
});
export { alpha, number, scale };